__webpack_require__.p = "//j1.58cdn.com.cn/ee/jxt-fe/jxt-webschool";